module.exports = __webpack_public_path__ + "static/media/1.2645fef8.png";